export default "__VITE_ASSET__DX0i5f3f__"